import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import LeaseApiService from '../../services/apiService';

const OtherDetails = ({ tableLoading, transectionData, setTransectionData, wipAccount, ownerList, setSelectedCity, handleCountryChange, countriesList, cityList, selectedCountry, selectedCity, }) => {
    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);

    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value }
            return updatedData;
        });
    };
    const handleDropDownChange = async ({ name, value }) => {
        setTransectionData(prev => ({ ...prev, [name]: value }));
    };
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}

                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Total Unit</label>
                        <input type="text" className="p-2 form-control w-75" disabled value={transectionData?.totalUnit} onChange={handleInputChange} name="totalUnit" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Retention Ac</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.retentionAcc}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'retentionAcc', value: selectedOption })}
                            options={wipAccount?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Total Parking(s)</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.totalParking} onChange={handleInputChange} name="totalParking" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Retention %</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.retentionPerc} onChange={handleInputChange} name="retentionPerc" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> No. of Floors</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.noOfFloor} onChange={handleInputChange} name="noOfFloor" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">WIP Account</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.wipAccount}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'wipAccount', value: selectedOption })}
                            options={wipAccount?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Sq.ft Rate</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.sqftRate} onChange={handleInputChange} name="sqftRate" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Agent Commission</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.agentCommission}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'agentCommission', value: selectedOption })}
                            options={cityList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Build Up Area</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.BuildUpArea} onChange={handleInputChange} name="BuildUpArea" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Contractor </label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.contractor} onChange={handleInputChange} name="contractor" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Gross Area </label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.grossArea} onChange={handleInputChange} name="grossArea" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Agent</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.agent} onChange={handleInputChange} name="agent" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Sub Contractor</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.subContractor} onChange={handleInputChange} name="subContractor" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">Sale Revenue Ac</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.saleRevenue}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'saleRevenue', value: selectedOption })}
                            options={wipAccount?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Sub Agent</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.subAgent} onChange={handleInputChange} name="subAgent" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Completion Date</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.completionDate}
                            onChange={(date) => handleDateChange({ name: 'completionDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                </div>
                <div className="cost-center-section my-3">
                    <div className="h6 py-2">Developer Details</div>
                    <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
                        {/* <div className="form-group grid-contain "> */}
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Developer</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.developer} onChange={handleInputChange} name="developer" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Sub Developer</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.subDeveloper} onChange={handleInputChange} name="subDeveloper" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact Person</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.devcontactPerson} onChange={handleInputChange} name="devcontactPerson" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact Person</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.subDevContactPerson} onChange={handleInputChange} name="subDevContactPerson" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.devContactNo} onChange={handleInputChange} name="devContactNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.subDevContact} onChange={handleInputChange} name="subDevContact" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Property Email</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.propertyEmail} onChange={handleInputChange} name="propertyEmail" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Accountant Email</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.accountantEmail} onChange={handleInputChange} name="accountantEmail" />
                        </div>
                    </div>
                </div>
                <div className="cost-center-section my-3">
                    <div className="h6 py-2">Other Details</div>
                    <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))', gap: '20px' }}>
                        {/* <div className="form-group grid-contain "> */}

                        <div className="d-flex">
                            <label htmlFor="validationCustom18" className="form-label">No</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={transectionData?.no}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'no', value: selectedOption })}
                                options={ownerList?.map(country => ({ value: country, label: country?.value }))}
                            />
                        </div>
                        <div className="d-flex gap-3">
                            <label className="form-check-label" htmlFor="createdtocheck">Same as Owner</label>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="asAsOwner"
                                style={{ width: '20px', height: '20px' }}
                                checked={transectionData.asAsOwner}
                                onChange={(e) => setTransectionData(prev => ({ ...prev, asAsOwner: e.target.checked }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom18" className="form-label">Name</label>
                            <Select
                                className="p-0 w-100"
                                theme={(theme) => ({
                                    ...theme,
                                    borderRadius: 5,
                                    padding: 9,
                                })}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                        color: state.isFocused ? "#000 " : "#000",
                                        ":hover": {
                                            backgroundColor: "#F5F5F5",
                                            color: "#000 ",
                                        },
                                    }),
                                }}
                                value={transectionData?.name}
                                onChange={(selectedOption) => handleDropDownChange({ name: 'name', value: selectedOption })}
                                options={ownerList?.map(country => ({ value: country, label: country?.text }))}
                            />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact Person</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.otherContactPerson} onChange={handleInputChange} name="otherContactPerson" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.otherContactNo} onChange={handleInputChange} name="otherContactNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.nameContactNo} onChange={handleInputChange} name="nameContactNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Email</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.otherEmail} onChange={handleInputChange} name="otherEmail" />
                        </div>
                        <div></div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Card Number</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.cardNo} onChange={handleInputChange} name="cardNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Bond Number</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.bondNo} onChange={handleInputChange} name="bondNo" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Bond Type</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.bondType} onChange={handleInputChange} name="name" />
                        </div>
                        <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Bond Date</label>
                            <DatePicker
                                todayButton="Today"
                                selected={transectionData?.bondDate}
                                onChange={(date) => handleDateChange({ name: 'bondDate', value: date })}
                                dateFormat="dd-MMM-yyyy"
                                style={{ width: '100px' }}
                                className="p-2 form-control w-100"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default OtherDetails